var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('upload-video-file',{staticStyle:{"width":"100%"},attrs:{"oldValue":_vm.oldValue,"size":_vm.size},on:{"change":_vm.handleChange}})}
var staticRenderFns = []

export { render, staticRenderFns }